<i18n src="./resources/locales.json"></i18n>
<template>
  <v-card color="surface lighten-1" class="contact-selection-form pa-2" width="510">
    <v-autocomplete
      ref="contactSelectionAutocomplete"
      v-model="selectedContacts"
      class="pt-3 px-2 pb-2"
      item-value="contactId"
      :items="availableContacts"
      :filter="filterContacts"
      :label="$t('addContactToGroupForm.addPeopleToGroup')"
      :placeholder="$t('addContactToGroupForm.searchPlaceholder')"
      :no-data-text="$t('addContactToGroupForm.noMatchesFound')"
      multiple hide-selected filled hide-details
      @blur="clearSearch"
    >
      <template v-slot:selection="{ item, parent }">
        <SmsChipItem :contact="item" @close="parent.selectItem(item)" />
      </template>
      <template v-slot:item="{ item }">
        <SmsContactItem :contact="item" />
      </template>
    </v-autocomplete>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="cancelAddContacts">{{ $t('addContactToGroupForm.cancel') }}</v-btn>
      <v-btn class="sms-primary-button" @click="addContactsToGroup">
        {{ $t('addContactToGroupForm.add') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import SmsChipItem from './SmsChipItem';
import SmsContactItem from '@/components/SmsContactItem/SmsContactItem';
import ToastMixin from '@/mixins/ToastMixin';

export default {
  name: 'SmsAddContactToGroupForm',

  components: { SmsChipItem, SmsContactItem },

  mixins: [ ToastMixin ],

  props: {
    group: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      selectedContacts: [],
      availableContacts: []
    };
  },

  computed: {
    ...mapGetters('contactsV2', ['currentUserContacts', 'enterpriseContacts'])
  },

  watch: {
    'group.id'() {
      this.initialize();
    },
    'selectedContacts.length'() {
      this.clearSearch();
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (!this.group.id) return;

      const onlyNotIncludedContacts =
        contact => !this.group.contacts.some(({ number }) => number === contact.number);
      const currentUserContacts = this.currentUserContacts.filter(onlyNotIncludedContacts);
      const enterpriseContacts = this.enterpriseContacts.filter(onlyNotIncludedContacts);
      let availableContactsList = [];

      if (currentUserContacts.length > 0) {
        availableContactsList.push({ header: 'My Contacts' });
        availableContactsList = availableContactsList.concat(currentUserContacts);
      }

      if (currentUserContacts.length > 0 && enterpriseContacts.length > 0) {
        availableContactsList.push({ divider: true });
      }

      if (enterpriseContacts.length > 0) {
        availableContactsList.push({ header: 'Enterprise Contacts' });
        availableContactsList = availableContactsList.concat(enterpriseContacts);
      }

      this.selectedContacts = [];
      this.availableContacts = availableContactsList;
    },

    filterContacts(contact, queryText) {
      if (contact.header || contact.divider) return true;
      return contact.includes(queryText);
    },

    addContactsToGroup() {
      this.$emit('selectionCompleted', { selection: this.selectedContacts })
    },

    cancelAddContacts() {
      this.$emit('close');
    },

    clearSearch() {
      this.$refs.contactSelectionAutocomplete.internalSearch = '';
    }
  }
};
</script>

<style>
.contact-selection-form .v-select__slot {
  padding: 12px 0;
  min-height: 80px;
}
.v-menu__content.v-menu__content--fixed.menuable__content__active.v-autocomplete__content {
  min-width: 280px !important;
  width: 316px;
}
</style>
